/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_SampleInputs */

const en_of_landing_sample = /** @type {(inputs: Of_Landing_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office space illustration`)
};

const id_of_landing_sample = /** @type {(inputs: Of_Landing_SampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilustrasi ruang kantor`)
};

/**
* | output |
* | --- |
* | "Office space illustration" |
*
* @param {Of_Landing_SampleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_sample = /** @type {((inputs?: Of_Landing_SampleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_SampleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_sample(inputs)
	return en_of_landing_sample(inputs)
});